<template>
    <div
        class="flex h-auto w-full flex-col items-start justify-start space-y-6"
    >
        <EditorField
            v-model="description"
            name="use_of_funds"
            label="campaign_marketing_use_of_funds_description"
            variant="minimal"
            help="help_campaign_marketing_use_of_funds_description"
            class="w-full"
        />
        <div class="flex h-auto w-full items-center justify-start space-x-6">
            <NumberField
                v-model="total"
                name="use_of_funds_total"
                label="campaign_marketing_use_of_funds_total"
                help="help_campaign_marketing_use_of_funds_total"
            />
            <NumberField
                v-model="threshold"
                name="use_of_funds_threshold"
                label="campaign_marketing_use_of_funds_threshold"
                help="help_campaign_marketing_use_of_funds_threshold"
            />
            <NumberField
                v-model="fullyFunded"
                name="use_of_funds_fully_funded"
                label="campaign_marketing_use_of_funds_fully_funded"
                help="help_campaign_marketing_use_of_funds_fully_funded"
            />
        </div>
        <CampaignUseOfFundsItems
            v-model="items"
            name-prefix="use_of_funds_items"
        />
    </div>
</template>

<script setup lang="ts">
import EditorField from '@src/components/EditorField.vue'
import NumberField from '@src/components/NumberField.vue'
import { CampaignUseOfFundsItem } from '@src/types'
import { useVModels } from '@vueuse/core'
import CampaignUseOfFundsItems from './CampaignUseOfFundsItems.vue'

const props = defineProps<{
    description: string | null
    total: number | null
    threshold: number | null
    fullyFunded: number | null
    items: CampaignUseOfFundsItem[]
}>()

const emit = defineEmits<{
    (e: 'update:description', value: string | null): void
    (e: 'update:total', value: number | null): void
    (e: 'update:threshold', value: number | null): void
    (e: 'update:fullyFunded', value: number | null): void
    (e: 'update:items', value: CampaignUseOfFundsItem[]): void
}>()

const { description, total, threshold, fullyFunded, items } = useVModels(
    props,
    emit
)
</script>
